import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./auth-context";

/**
 * Gate for the authenticated application. Anonymous visitors are sent to the
 * login screen at `/`, carrying the path they wanted so sign-in can return them.
 */
export function RequireAuth({ children }: { children: ReactNode }): ReactNode {
  const { status, error } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted" role="status">
        Loading…
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="flex min-h-screen items-center justify-center p-8" role="alert">
        <p className="max-w-md text-center text-danger">
          {error?.message ?? "The workspace could not be reached."}
        </p>
      </div>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}
